import { get } from 'svelte/store';

import { AWARD_PAGE_EXPOSE_SW } from '../enums/track';
import { receiveReward, type ReceiveRewardData } from '../model/receive';
import { activityId, userID } from '../store/index';

import { resolveBallPageId } from './ballPageId';
import { saveRewardClaim } from './rewardClaimStorage';
import { trackEvent } from './track';

import { getCookie } from '@/utils/cookie';
import { trackEventModuleSw } from '@/utils/techTrack';

const resolveRewardActivityId = (res: ReceiveRewardData) =>
    res?.activityFullDTOList?.[0]?.activityDTO?.activityId ?? '';

export const receiveRewardAndSaveClaim = async (uidOverride?: string) => {
    const res = await receiveReward();
    const rewardActivityId = resolveRewardActivityId(res);

    if (rewardActivityId) {
        activityId.set(String(rewardActivityId));
    }

    trackEventModuleSw('receive_reward_success');
    saveRewardClaim({
        pageId: resolveBallPageId(),
        uid: uidOverride ?? getCookie('uid') ?? get(userID) ?? '',
        activityId: String(rewardActivityId)
    });
    trackEvent(AWARD_PAGE_EXPOSE_SW, {
        result: 1
    });

    return rewardActivityId;
};

export const trackReceiveRewardFailure = (err: unknown) => {
    const error = err as {
        errno?: number | string;
        errmsg?: string;
        message?: string;
    };
    const message = (error?.message ?? '').toString();
    const isTimeout = /timeout|time out/i.test(message);

    trackEvent(AWARD_PAGE_EXPOSE_SW, {
        result: 0,
        error_msg: error?.errmsg || message || 'receive_reward_failed',
        error_code: error?.errno || (isTimeout ? 'timeout' : '1005')
    });

    if (isTimeout) {
        trackEventModuleSw('receive_reward_timeout');
    }

    trackEventModuleSw('receive_reward_fail');
};
